export default function VideoModal({videoUrl, onClose}) {
    if (!videoUrl) return null;

    return (
        <div
            className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4 backdrop-blur-sm"
            onClick={onClose}
        >
            <div
                className="relative max-w-3xl w-full bg-white rounded-2xl overflow-hidden shadow-2xl"
                onClick={e => e.stopPropagation()}
            >
                <button
                    className="absolute top-3 right-3 w-10 h-10 bg-white rounded-full flex items-center justify-center text-gray-600 hover:bg-gray-100 transition z-10 shadow-lg"
                    onClick={onClose}
                >
                    ✕
                </button>
                <video controls autoPlay className="w-full">
                    <source src={videoUrl} type="video/mp4"/>
                </video>
            </div>
        </div>
    );
}
